import React from "react";
import { withRouter, useHistory } from "react-router-dom";
import { Image, Row, Typography } from "antd";
import { useUser } from "providers/user";
import { HomeOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";

import Logo from "./logo.png";

const { Text } = Typography;

const Sidebar = () => {
  const location = useLocation();
  const { user } = useUser();
  const { push } = useHistory();

  return (
    <div
      style={{
        width: 240,
        background: "white",
        height: "100vh",
        flexShrink: 0,
      }}
    >
      <Row
        style={{ justifyContent: "center", cursor: "pointer" }}
        onClick={() => push("/dashboard")}
      >
        <Image
          style={{
            display: "block",
            paddingLeft: 40,
            marginTop: 30,
            paddingRight: 40,
          }}
          height={21}
          preview={false}
          src={Logo}
          alt=""
        />
      </Row>
      <Row style={{ justifyContent: "center" }}>
        <div
          style={{
            marginTop: 70,
            borderRadius: 20,

            overflow: "hidden",
          }}
        >
          <Image
            style={{
              display: "block",
              background: "black",
              borderRadius: 50,
            }}
            height={80}
            src={
              user?.clientLead?.img ? user?.clientLead?.img : "icons/veikul.png"
            }
            alt=""
          />
        </div>
      </Row>
      <div style={{ alignItems: "center", textAlign: "center", marginTop: 5 }}>
        <Text style={{ fontWeight: "800", fontSize: 15 }}>
          {user?.client?.name}
        </Text>
        <br />
        <Text style={{ color: "#8c8c8c" }}> {user?.email}</Text>
        <br />
        <Text style={{ fontSize: 18 }} strong>
          {" "}
          {user?.clientLead?.name}
        </Text>
        <br />
      </div>
      <div
        style={{
          display: "flex",
          marginTop: 40,
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div>
          <Link to={"/dashboard"} style={{ marginLeft: 10, cursor: "pointer" }}>
            <Row
              style={{
                alignItems: "center",
                width: 180,
                background:
                  location.pathname === "/dashboard" ? "#142b22" : "none",
                padding: 5,
                paddingLeft: 15,
                paddingRight: 15,
                borderRadius: 20,
              }}
            >
              <HomeOutlined
                style={{
                  fontSize: 18,
                }}
              />
              <Text
                style={{
                  fontSize: 17,
                  marginLeft: 10,
                  color:
                    location.pathname === "/dashboard" ? "white" : "#8c8c8c",
                  fontWeight: "900",
                }}
              >
                Informacion
              </Text>
            </Row>
          </Link>

          <Link to={"/profile"} style={{ marginLeft: 10, cursor: "pointer" }}>
            <Row
              style={{
                alignItems: "center",
                width: 180,
                background:
                  location.pathname === "/profile" ? "#142b22" : "none",
                padding: 5,
                paddingLeft: 15,
                paddingRight: 15,
                borderRadius: 20,
              }}
            >
              <UserSwitchOutlined
                style={{
                  fontSize: 18,
                }}
              />
              <Text
                style={{
                  fontSize: 17,
                  marginLeft: 10,
                  color: location.pathname === "/profile" ? "white" : "#8c8c8c",
                  fontWeight: "900",
                }}
              >
                Mi Perfil
              </Text>
            </Row>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Sidebar);
